import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Modal, ModalOptions } from '@indice/ng-components';
import { Address, NotificationFrequency, PropertyListFilter } from 'src/app/services/portal-api.service';
import { PropertyListingService } from 'src/app/services/property.service';
import { CustomTooltipDirective } from 'src/app/shared/directives/custom-tooltip.directive';
import { catchError, forkJoin, iif, map, mergeMap, of, pipe, switchMap, take } from 'rxjs';
import { ToasterService, ToastType } from 'src/app/services/toaster.service';
import { GeocodeService } from 'src/app/core/services/geocode.service';

@Component({
  selector: 'app-save-search-modal',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, TranslocoDirective, CustomTooltipDirective],
  templateUrl: './save-search-modal.component.html',
  styleUrl: './save-search-modal.component.css'
})
export class SaveSearchModalComponent {

  @Input() SearchFilters: PropertyListFilter | undefined;
  protected frequency: NotificationFrequency = NotificationFrequency.Weekly;
  protected frequencyTypes = NotificationFrequency
  form = new UntypedFormGroup({
    name: new UntypedFormControl('', Validators.required),
  });

  constructor(
    public modalRef: Modal,
    private t: TranslocoService,
    @Inject(ModalOptions) private _options: ModalOptions,
    private toasterService: ToasterService,
    private _geocodeService: GeocodeService,
    private _propertyListingService: PropertyListingService) { }

  ngOnInit(): void {
    this.SearchFilters = (this._options?.initialState?.['SearchFilters'] as PropertyListFilter);
    this.clearSearchFilter()
  }


  close = () => this.modalRef.hide({ name: this.form.get('name')?.value });

  clearSearchFilter = () => {
    const areas: string[] = this.SearchFilters?.searchTerm?.split('!')?.map(term => term.split('~')[2]) ?? []
    this.SearchFilters!.area = areas.join('!')
  }

  public onFrequencyClick(selectedFreq: any | undefined) {
    this.frequency = selectedFreq;
  }

  save = () => {
    this.clearSearchFilter()    
    const placeIds = this.getPlaceIds();
    this.getPlaces(placeIds)
      .pipe(switchMap(places => {
        const address = places.map(place => new Address({
          postalCode: place.PostalCode,
          administrativeAreas: place.AdministrativeAreas,
          country: place.Country,
          geoPoint: (place.Lat && place.Lon) ? `${place.Lat},${place.Lon}` : undefined,
          prefecture: place.Prefecture,
          streetNumber: place.StreetNumber,
          streetName: place.StreetName,
        }));
        return this._propertyListingService.saveSearch(this.SearchFilters, this.form.get('name')?.value, undefined, address, this.frequency)
      }),
      catchError((error: any) => {
        this.toasterService.showModal(ToastType.Info, this.t.translate('saved.search.title'), this.t.translate(error?.detail))
        return of(error)
      }),
      map(x => {
        this.modalRef.hide({ name: this.form.get('name')?.value }), 's'
      })
      ).subscribe();
  }

  private getPlaceIds(): string[] {
          var searchTerm = this.SearchFilters?.searchTerm;
          let placeIds: string[] = [];
          const areas = searchTerm?.split('!') ?? [];
          areas.forEach(area => {
              let arr = area?.split('~') ?? [];
              // Step 2: Exclude the last value
              arr.pop();
              // Step 3: Take one, leave one, take one, leave one
              
              for (let i = 0; i < arr.length; i += 2) {
                  placeIds.push(arr[i]);
              }
          })
  
          return placeIds;
      }
  
      private getPlaces(ids: string[]) {
          if (ids.length === 0) {
              return of([]);
          }
          const observables = ids.map(placeId => this._geocodeService.getPlaceById(placeId!).pipe(take(1)));
          return forkJoin(observables);
      }
}
